import http from "./httpService";
const Urlapi = "https://api-mobileapp.advanceagro.net";
//const Urlapi = "http://localhost:3001";


export async function getqueueplan(queuedate,id) {
  return http.get(Urlapi+"/wms/getqueueplan?startdate=" + queuedate +"&branchid="+id);
}

export async function getWeightlist(
  start = "",
  end = "",
  branchid = "",
  typeid = "0",
  search = "",
  pageSize = 1000,
  pageNumber = 1
) {
  // console.log('cusid=',search);
  return http.get(
    "/JAWIS/Weightlist?startdate=" +
      start +
      "&enddate=" +
      end +
      "&branchid=" +
      branchid +
      "&typeid=" +
      typeid +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber +
      "&search=" +
      search
  );
}

export async function WoodReceiveWeeklyAA() {
  return http.get("/ips/WoodReceiveWeekly?BranchID=AA");
}

export async function ReportWoodChip(
  reportcode = "R01",
  startdate = "",
  enddate = "",
  storeId
) {
  return http.get(
    "/report/ReportWoodChip?ReportCode=" +
      reportcode +
      "&StartDate=" +
      startdate +
      "&EndDate=" +
      enddate +
      "&StorageID=" +
      storeId
  );
}
export async function getCCP(
  startdate = "",
  enddate = "",
  pageSize = 1000,
  pageNumber = 1
) {
  return http.get(
    "/jawis/getresultReceive?startdate=" +
      startdate +
      "&enddate=" +
      enddate +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber
  );
}
export async function getCustomerList(
  id = "",
  name = "",
  pageSize = 1000,
  pageNumber = 1
) {
  return http.get(
    "/wms/getCustomerList?BranchID=" +
      id +
      "&name=" +
      name +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber
  );
}
export async function getDrivenlist(
  id = "",
  name = "",
  pageSize = 1000,
  pageNumber = 1
) {
  return http.get(
    "/wms/getDrivenlist?id=" +
      id +
      "&name=" +
      name +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber
  );
}

export async function getQueue() {
  return http.get(
    "https://wms.advanceagro.net/ws2/api/wms/getQueuePower?branchid=503"
  );
}
export async function getEditresult(id = 0) {
  return http.get("/jawis/getEditresult?id=" + id);
}
export async function getCustomerType(id) {
  return http.get("/wms/getCustomerType?BranchID=" + id);
}
export async function getCustomer(id) {
  return http.get("/wms/getCustomer?BranchID=" + id);
}
export async function getSourceProduct(id) {
  return http.get("/wms/getProductsource?id=" + id);
}
export async function getstatustail(id,Typecode) {
  return http.get("/CR/CheckWeightStatus?BranchID=" + id + "&TypeCode=" + Typecode);
}


export async function GetCompany(id, pid) {
  return http.get("/wms/GetCompanyData?branchid=" + id + "&id=" + pid);
}

export async function getGroupTruck(id) {
  return http.get("/wms/getGroupTruck?branchid=" + id);
}
export async function getDriven(branchid, id = 0) {
  return http.get("/wms/getDriven?branchid=" + branchid + "&id=" + id);
}
export async function getQueueWoodchip(startdate, id) {
  return http.get(
    "/wms/getQueueWoodchip?startdate=" + startdate + "&prodid=" + id
  );
}
export async function getqueueonline(branchid, id) {
  return http.get(
    "/general/CheckQueueByProduct?BranchID=" + branchid + "&productId=" + id
  );
}

export async function GetBranch() {
//   const token = getJwt()
//  console.log(token)
// //  http.getaxios.defaults.headers["x-auth-token"] = token
  return http.get("/wms/GetBranch");
}
export async function SaveCCP(doc) {
  return http.post("/jawis/SaveCCP", doc);
}
export async function saveRC(doc) {
  return http.post("/wms/SaveRC", doc);
}
export async function UploadFaceImage(doc) {
  return http.post(
    "https://wms.advanceagro.net/wsface/api/face/InputProfile",
    doc
  );
}
export async function savtruckover(doc) {
  return http.post("/wms/SaveOverTime", doc);
}
export async function getRegisterlist(
  start = "",
  end = "",
  branchid = "",
  cusid = "0",
  search = "",
  pageSize = 1000,
  pageNumber = 1,typeid=0
) {
  // console.log('cusid=',pageNumber);
  return http.get(
    "/wms/RegisterList?startdate=" +
      start +
      "&enddate=" +
      end +
      "&branchid=" +
      branchid +
      "&cusid=" +
      cusid +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber +
      "&search=" +
      search +"&typeid=" + typeid 
  );
}

export async function getproducttypelist(branchid) {
  return http.get("/wms/GetProductTypelist?branchid="+branchid)
}
export async function Weightlist(
  start = "",
  end = "",
  branchid = "",
  cusid = "0",
  proid = 0,
  search = "",
  pageSize = 1000,
  pageNumber = 1
) {
  // 27.0.0.1:8080/api/wms/getWeightTotal?startdate=2021-09-08&enddate=2021-09-08&branchid=503&typeid=0&productid=0&search=
  return http.get(
    "/wms/getWeightlist?startdate=" +
      start +
      "&enddate=" +
      end +
      "&branchid=" +
      branchid +
      "&typeid=" +
      cusid +
      "&productid=" +
      proid +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber +
      "&search=" +
      search
  );
}
export async function WeightTotal(
  start = "",
  end = "",
  branchid = "",
  cusid = "0",
  proid = 0,
  search = ""
) {
  return http.get(
    "/wms/getWeightTotal?startdate=" +
      start +
      "&enddate=" +
      end +
      "&branchid=" +
      branchid +
      "&typeid=" +
      cusid +
      "&productid=" +
      proid +
      "&search=" +
      search
  );
}
export async function getPrivilege() {
  return http.get("/wms/getPrivilege");
}

export async function getSumaryRegister(start = "", end = "", id) {
  // console.log(start,id,end);
  return http.get(
    "/wms/getSumaryRegister?id=" +
      id +
      "&StartDate=" +
      start +
      "&EndDate=" +
      end
  );
}
export async function getMonitorECE(id, startDate) {
  return http.get(
    "/wms/getMonitorECE?branchid=" + id + "&startdate=" + startDate
  );
}

export async function getregister(webid, id) {
  return http.get("/wms/WebRegisterEdit?branchid=" + id + "&webid=" + webid);
}
export async function weightdetail(id) {
  return http.get("/wms/weightdetail?weightno=" + id);
}
export async function weightmonitor(id, startDate) {
  return http.get(
    "/wms/getweightMonitor?startdate=" + startDate + "&productid=" + id
  );
}
export async function weightperhour(id, startDate) {
  return http.get(
    "/wms/getweightperhour?startdate=" + startDate + "&branchid=" + id
  );
}
export async function queuetdetail(id, branchid) {
  return http.get("/wms/queuedetail?queueid=" + id + "&branchid=" + branchid);
}
export async function getstore( branchid) {
  return http.get("/general/GetStore?branchid=" + branchid);
}


export async function gettotalBooking(id, startDate, branchid) {
  return http.get(
    "/wms/gettotalBooking?startdate=" +
      startDate +
      "&prodid=" +
      id +
      "&branchid=" +
      branchid
  );
}
export async function getReport(
  id,
  startDate,
  endDate,
  branchid,
  pageSize,
  pageNumber,storeid
) {
  return http.get(
    "/wms/getReport?reportcode=" +
      id +
      "&startdate=" +
      startDate +
      "&enddate=" +
      endDate +
      "&branchid=" +
      branchid +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber +"&storeid="+ storeid
  );
}
export async function getdatabranch() {
  return http.get(
    Urlapi + "/wms/getbranch"
  );
}
export async function getdatafsc() {
   //return http.get("http://127.0.0.1:3001/wms/getdatafsc");
   return http.get(Urlapi + "/wms/getdatafsc");
}

export async function checkaccess(id,page="register") {
  return http.get("/wms/checkcaccess?branchid="+id+"&page="+page);
}
export async function getTreetype(branchid) {
  return http.get("/wms/getTreeType?branchid=" + branchid);
}
export async function getCustomerIDWeb(branchid) {
  return http.get("/wms/CustomerIDWeb?branchid=" + branchid);
}
export async function GetprivilegePage(page = "", id) {
  //wms/getWoodchipSumary?startdate=2021-02-23&branchid=520&id=0
  return http.get("/wms/GetprivilegePage?Page=" + page + "&branchid=" + id);
}
export async function GetQueuebranch(date, branch) {
  return http.get(
    Urlapi + "/wms/queuecr?startdate=" + date + "&branchid=" + branch
  );
}
export async function GetQueueDetail(ID, branch) {
  return http.get(
    Urlapi + "/wms/queuecrdetail?id=" + ID + "&branchid=" + branch
  );
}
export async function getWoodchipSumary(branchid, startDate, id) {
  return http.get(
    "/wms/getWoodchipSumary?startdate=" +
      startDate +
      "&branchid=" +
      branchid +
      "&id=" +
      id
  );
}
export async function getAASumary(startDate, id) {
  return http.get("/wms/getAASumary?startdate=" + startDate + "&id=" + id);
}
export async function getMemulist(branchid) {
  return http.get(Urlapi + "/wms/menu/" + branchid);
}
export async function ConfirmData(doc) {
  return http.post(
    "https://wms.advanceagro.net/wsface/api/face/ConfirmData",
    doc
  );
}
export async function GetRegisterface(
  start = "",
  end = "",
  branchid = "",
  Status = "0",
  search = "",
  pageSize = 100,
  pageNumber = 1
) {
  return http.get(
    "https://wms.advanceagro.net/wsface/api/face/GetRegister?startdate=" +
      start +
      "&enddate=" +
      end +
      "&BranchID=" +
      branchid +
      "&Status=" +
      Status +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber
  );
}
export async function getQueueMonitor(branchid,startdate,cid,truckid =0,id=0) {
  return http.get(Urlapi + "/wms/queueplan?branchid=" + branchid + "&startdate=" + startdate + 
  "&cid=" + cid +"&truckid=" + truckid +"&id="+id );
}

export async function getQueuMax(branchid, startdate, typeid) {
  return http.get(
    "/wms/GetMaxPerHour?branchid=" +
      branchid +
      "&queue_date=" +
      startdate +
      "&typeid=" +
      typeid
  );
}

export async function getQueuePlan(
  branchid,
  startdate,
  typeid = 0,
  truckid = 0
) {
  return http.get(
    Urlapi +
      "/wms/queueplan501?branchid=" +
      branchid +
      "&startdate=" +
      startdate +
      "&typeid=" +
      typeid +
      "&truckid=" +
      truckid
  );
}
export async function getQueueActual(branchid,startdate,proid,truckid =0,id = 0) {

  return http.get(Urlapi + "/wms/queueactual?branchid=" + branchid + "&startdate=" + startdate + 
  "&proid=" + proid +"&truckid=" + truckid +"&id="+id);
}
export async function getQueueActual501(
  branchid,
  startdate,
  typeid = 0,
  truckid = 0
) {
  return http.get(
    Urlapi +
      "/wms/queueactual501?branchid=" +
      branchid +
      "&startdate=" +
      startdate +
      "&typeid=" +
      typeid +
      "&truckid=" +
      truckid
  );
}
export async function productgroup(branchid) {
  return http.get("/wms/ProductGroup?branchid=" + branchid);
}
export async function trucklistgroup(branchid) {
  return http.get("/wms/getTruckGroup?branchid=" + branchid);
}
export async function ConfirmToken() {
  return http.get("/wms/ConfirmToken");
}
export async function getqueuedetail(id, branchid) {
  return http.get("/wms/getqueuedetail?branchid=" + branchid + "&id=" + id);
}
export async function getWeightDetail(id) {
  return http.get("/wms/getWeightDetail?weightno=" + id);
}
export async function getQueueConfig(branchid) {
  return http.get("/wms/getQueueConfig?branchid=" + branchid);
}
export async function getBranchList() {
  return http.get("/wms/getWoodChipBranch");
}
export async function downLoadExcel(
  startDate,
  endDate,
  branchid,
  type = "",
  search = "",
  truckid = 0
) {
  return http.get(
    Urlapi +
      "/download/toexcelfacmaster?startdate=" +
      startDate +
      "&enddate=" +
      endDate +
      "&branchid=" +
      branchid +
      "&type=" +
      type +
      "&search=" +
      search +
      "&truckid=" +
      truckid,
    { responseType: "blob" }
  );
}

export async function getWoodChipReport(startDate, endDate, branchid) {
  return http.get(
    "/wms/getWoodChipReport?startdate=" +
      startDate +
      "&enddate=" +
      endDate +
      "&BranchID=" +
      branchid
  );
}

export async function getWoodChipToProduce(startDate, endDate, branchid) {
  return http.get(
    Urlapi +
      "/wms/produce?startdate=" +
      startDate +
      "&enddate=" +
      endDate +
      "&branchid=" +
      branchid
  );
}
export async function getPrivilegeExcel(branchid) {
  return http.get("/wms/PrivilegeExcel?branchid=" + branchid);
}
export async function getCurrentCar(id = 0) {
  return http.get(Urlapi + "/wms/carcurrent/" + id);
}

export async function getCarDetail(branchid = 0, statusid = 4, ID = 2) {
  return http.get(
    Urlapi +
      "/wms/cardetail?branchid=" +
      branchid +
      "&statusid=" +
      statusid +
      "&id=" +
      ID
  );
}
export async function getImage(id, action, camid, branchid) {
  return http.get(
    "/image/GetImageByWeightNo?weightno=" +
      id +
      "&action=" +
      action +
      "&camid=" +
      camid +
      "&branchid=" +
      branchid
  );
}

export async function getDrivenlists(search = "") {
  return http.get(Urlapi + "/wms/drivenlist?search=" + search);
}

export async function gettruckover(
  ID,
  startdate,
  enddate,
  hourid = 0,
  statusid = 0,
  pageSize = 30,
  pageNumber = 1
) {
  //console.log("Server",start,TypeID,end);
  return http.get(
    Urlapi +
      "/wms/getruckover?id=" +
      ID +
      "&startdate=" +
      startdate +
      "&enddate=" +
      enddate +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber +
      "&hourid=" +
      hourid +
      "&statusid=" +
      statusid
  );
}
export async function getProductType(id) {
  return http.get("/General/ProductType?BranchID=" + id);
}
export async function getProduct(id, typeid) {
  return http.get("/General/Product?BranchID=" + id + "&type_id=" + typeid);
}
export async function getMasterRequest() {
  return http.get("/hub/getMasterRequest");
}
export async function getMasterStatus() {
  return http.get("/hub/getMasterStatus");
}
export async function getdataapprove(statusid,masterid,startDate,endDate) {
    //return http.get("http://127.0.0.1:3001/wms/getdataapprove?statusid=" + statusid + "&masterid=" + masterid + "&startdate="+ startDate + "&enddate="+ endDate)
   return http.get(Urlapi+"/wms/getdataapprove?statusid=" + statusid + "&masterid=" + masterid + "&startdate="+ startDate + "&enddate="+ endDate)
}
export async function getmasterstore(id) {
  // return http.get("/wms/getstore?branchid=" + id);
  return http.get(Urlapi + "/wms/getstore?branchid=" + id);
}
export async function getMasterdestination(id) {
  return http.get(Urlapi + "/wms/getdestination?branchid=" + id);
  // return http.get("/wms/getdestination?BranchID=" + id);
}
export async function getweighttail(id) {
  return http.get(Urlapi + "/wms/getweighttail?branchid=" + id);
  // return http.get("/wms/getdestination?BranchID=" + id);
}
export async function saveapprove(doc) {
  return http.post(Urlapi+"/wms/saveapprove", doc); 
}
export async function getdataweightno(branchid,datestart,dateend,pageSize =30, pageNumber =1,search="",id=0) {
  return http.get(Urlapi+"/wms/getdataweightno?branchid=" + branchid + "&datestart=" + datestart 
  + "&dateend=" + dateend +"&pageSize="+ pageSize +"&pageNumber="+pageNumber +"&search="+ search +"&id="+ id);
  // return http.get("http://127.0.0.1:3001/wms/getdataweightno?branchid=" + branchid + "&datestart=" + datestart 
  // + "&dateend=" + dateend +"&pageSize="+ pageSize +"&pageNumber="+pageNumber +"&search="+ search +"&id="+ id);
}
export async function getcustomer(branchid,name) {
  return http.get("/hub/getcustomer?branchid=" + branchid + "&name=" + name);
}
export async function saverequest(doc) {
  return http.post(Urlapi+"/wms/saverequestdata", doc);
  //return http.post("http://127.0.0.1:3001/wms/saverequestdata", doc)
}
export async function searchcustomer(branchid,customername="") {
  return http.get(Urlapi+"/wms/searchcustomer?branchid="+ branchid +"&CustomerName="+ customername);
}
export async function checkdo(branchid,DO="") {
  return http.get("/General/ConfirmDO?BranchID="+ branchid +"&DO="+ DO);
}
export async function getcustomertype(branchid) {
  return http.get(Urlapi+"/wms/getcustomertype?branchid="+ branchid );
}
export async function checkdo2(branchid,DO,customerid) {
  return http.get("/General/ConfirmDO2?BranchID="+ branchid +"&DO="+ DO +"&CustomerTypeID="+ customerid);
}
//saverequest
export async function getProductGroup(branchid) {
  return http.get("/wms/getProductGroup?branchid="+ branchid);
}
export async function getCustomerTypehub() {
  return http.get("/hub/getCustomerType?");
}
export async function getFacDaily(weightno) {
  return http.get("/hub/getFacDaily?weightno="+ weightno);
}
export function savedatacustomer(doc) {

    return http.post(Urlapi+"/wms/savedatacustomer", doc);
 // }
}
export async function getProvince(id) {
  return http.get("/general/Province?BranchID=" + id);
}
export async function checkTosap(weightno) {
  return http.get("/woodchip/CheckSendToSAP?WeightNo=" + weightno);
  // return http.get("http://wms.advanceagro.net/WS2/api/woodchip/CheckSendToSAP?WeightNo=" + weightno);
}
export async function confiremDo(branchid,doid,CustomerTypeID) {
  return http.get("/general/ConfirmDO?BranchID=" + branchid + "&DO=" + doid + "&CustomerTypeID=" + CustomerTypeID);
  // return http.get("http://wms.advanceagro.net/WS2/api/woodchip/CheckSendToSAP?WeightNo=" + weightno);
}
export async function checkDoWood(doid,branchid="") {
  return http.get("/wms/?referno=" + doid +"&branchid="+ branchid);
}
export async function getOwnercustomer(id) {
   return http.get("/wms/getOwnercustomer?branchid=" + id);
  // return http.get("http://127.0.0.1:3001/wms/getOwnercustomer?branchid=" + id);
}
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getCarDetail,
  getWoodChipToProduce,
  getImage,getQueueConfig,getQueueMonitor,
  getqueuedetail,getWeightDetail,
  getCurrentCar,productgroup,
  trucklistgroup,getWeightlist,
  getTreetype,getPrivilegeExcel,
  WoodReceiveWeeklyAA,ReportWoodChip,
  getCCP,getEditresult,
  SaveCCP,getCustomerType,
  getCustomer,getCustomerList,
  getDrivenlist,getSourceProduct,
  GetCompany,getGroupTruck,getDriven,
  GetBranch,
  getPrivilege,getregister,
  getSumaryRegister,getMonitorECE,
  weightdetail, weightmonitor,
  weightperhour,getQueueWoodchip,
  queuetdetail,gettotalBooking,
  ConfirmToken, getBranchList,
  getWoodChipReport,
  getReport,getCustomerIDWeb,
  GetprivilegePage,Weightlist,
  getWoodchipSumary,getMemulist,
  downLoadExcel,saveRC,
  getAASumary,
  gettruckover,getDrivenlists,
  getqueueonline,
  GetQueuebranch,GetQueueDetail,
  getMasterRequest,getMasterStatus,
  getcustomer,getFacDaily,getdatafsc,
  getdatabranch,savedatacustomer,getOwnercustomer,
  saveapprove,getdataweightno,saverequest,getProvince,checkTosap,checkDoWood
};
